<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <el-container style="height: 600px">
            <el-header>
                <el-form :model="searchData" :inline="true" class="demo-form-inline" style="margin-top: 10px">
                    <el-form-item label="日期:">
                        <el-date-picker
                            v-model="searchData.dataTime"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            value-format="yyyy-MM-dd"
                            @change="onDatePickerChange"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label>
                        <el-input v-model="searchData.setName" placeholder="请填写班次名称"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button size="medium" class="btn-primary" @click="getEntpScheduleList">查找</el-button>
                    </el-form-item>
                </el-form>
            </el-header>
            <el-container style="height: 100%">
                <el-aside width="20%">
                    <el-card shadow="never" style="padding: 25px; height: 100%; overflow: auto">
                        <el-row>
                            <el-col :span="24">
                                <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
                            </el-col>
                        </el-row>
                        <el-tree
                            check-strictly
                            highlight-current
                            default-expand-all
                            :data="orgList"
                            ref="tree"
                            :filter-node-method="filterNode"
                            node-key="Id"
                            :props="treeProps"
                            @node-click="handleNodeClick"
                        ></el-tree>
                    </el-card>
                </el-aside>
                <el-main width="80%" style="height: 100%; padding: 0px 20px">
                    <el-container v-if="tableVisible" style="height: 100%">
                        <el-table :data="entpScheduleList" border height="100%" style="width: 100%" @selection-change="handleSelectionChange" fit>
                            <el-table-column type="selection" width="55"></el-table-column>
                            <el-table-column prop="StaffName" label="姓名" min-width="150"></el-table-column>
                            <el-table-column prop="SetName" label="班次名" min-width="150"></el-table-column>
                            <el-table-column prop="SetTypeName" label="工作班次" min-width="150"></el-table-column>
                            <el-table-column prop="StartTime" label="开始日期" min-width="150"></el-table-column>
                            <el-table-column prop="EndTime" label="结束日期" min-width="150"></el-table-column>
                            <el-table-column prop="IsTemp" label="临时排班" min-width="150">
                                <template slot-scope="scope">
                                    <span>{{ getIsTempValue(scope) }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作">
                                <template slot-scope="scope">
                                    <div class="ops-ctn">
                                        <el-button type="text" size="mini" v-if="permission.edit" @click="showEditStaffSchedule(scope)">编辑</el-button>
                                        <el-button type="text" size="mini" v-if="permission.del" @click="delStaffSchedule(scope)">{{ permission.del }}</el-button>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="pagination-ctn">
                            <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="searchData.page"
                                :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                                :page-size="searchData.limit"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="entpScheduleList.length"
                            ></el-pagination>
                        </div>
                    </el-container>
                    <el-container v-else style="height: 100%">
                        <el-row class="rowClass">
                            <el-col :span="24">
                                <el-button-group style="width: 100%; padding: 0px; margin-bottom: 10px">
                                    <el-button class="btn-primary" size="small" style="width: 120px" @click="getStaffWeekSchedule(2)">上一周</el-button>
                                    <el-button class="btn-primary" size="small" style="width: 120px" @click="getStaffWeekSchedule(1)">本周</el-button>
                                    <el-button class="btn-primary" size="small" style="width: 120px" @click="getStaffWeekSchedule(3)">下一周</el-button>
                                </el-button-group>
                            </el-col>
                            <el-col :span="24">
                                <el-table :data="staffWeekScheduleList" border style="width: 100%; padding: 0px; margin-bottom: 10px" fit>
                                    <el-table-column prop="StaffName" label="姓名" min-width="150"></el-table-column>
                                    <el-table-column prop="SetName" label="班次名" min-width="150"></el-table-column>
                                    <el-table-column prop="SetTypeName" label="工作班次" min-width="150"></el-table-column>
                                    <el-table-column prop="StartTime" label="开始日期" min-width="150"></el-table-column>
                                    <el-table-column prop="EndTime" label="结束日期" min-width="150"></el-table-column>
                                    <el-table-column prop="IsTemp" label="临时排班" min-width="150">
                                        <template slot-scope="scope">
                                            <span>{{ getIsTempValue(scope) }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="操作">
                                        <template slot-scope="scope">
                                            <div class="ops-ctn">
                                                <el-button type="text" size="mini" v-if="permission.edit" @click="showEditStaffSchedule(scope)">编辑</el-button>
                                                <el-button type="text" size="mini" v-if="permission.del" @click="delStaffSchedule(scope)">删除</el-button>
                                            </div>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </el-col>
                            <el-col :span="24">
                                <el-table
                                    :data="myWorkTimeData"
                                    :span-method="cellMerge"
                                    border
                                    fit
                                    style="width: 100%"
                                    :header-cell-style="{ background: '#F2F6FC', align: 'center' }"
                                >
                                    <el-table-column align="center" type="index" :index="indexMethod" label="周期/时间" width="160px"></el-table-column>
                                    <el-table-column header-align="center" label="0" width="60px">
                                        <template slot-scope="scope">
                                            <div :key="index" v-for="(item, index) in scope.row.Times">
                                                <el-popover placement="top-start" :title="item.Name" width="200" trigger="hover" :content="item.SpanText">
                                                    <el-tag slot="reference" :style="getTagStyle(item)" size="medium" :color="tagColor(item)">{{ getTagValue(item) }}</el-tag>
                                                </el-popover>
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column header-align="center" label="1" width="60px"></el-table-column>
                                    <el-table-column header-align="center" label="2" width="60px"></el-table-column>
                                    <el-table-column header-align="center" label="3" width="60px"></el-table-column>
                                    <el-table-column header-align="center" label="4" width="60px"></el-table-column>
                                    <el-table-column header-align="center" label="5" width="60px"></el-table-column>
                                    <el-table-column header-align="center" label="6" width="60px"></el-table-column>
                                    <el-table-column header-align="center" label="7" width="60px"></el-table-column>
                                    <el-table-column header-align="center" label="8" width="60px"></el-table-column>
                                    <el-table-column header-align="center" label="9" width="60px"></el-table-column>
                                    <el-table-column header-align="center" label="10" width="60px"></el-table-column>
                                    <el-table-column header-align="center" label="11" width="60px"></el-table-column>
                                    <el-table-column header-align="center" label="12" width="60px"></el-table-column>
                                    <el-table-column header-align="center" label="13" width="60px"></el-table-column>
                                    <el-table-column header-align="center" label="14" width="60px"></el-table-column>
                                    <el-table-column header-align="center" label="15" width="60px"></el-table-column>
                                    <el-table-column header-align="center" label="16" width="60px"></el-table-column>
                                    <el-table-column header-align="center" label="17" width="60px"></el-table-column>
                                    <el-table-column header-align="center" label="18" width="60px"></el-table-column>
                                    <el-table-column header-align="center" label="19" width="60px"></el-table-column>
                                    <el-table-column header-align="center" label="20" width="60px"></el-table-column>
                                    <el-table-column header-align="center" label="21" width="60px"></el-table-column>
                                    <el-table-column header-align="center" label="22" width="60px"></el-table-column>
                                    <el-table-column header-align="center" label="23" width="60px"></el-table-column>
                                </el-table>
                            </el-col>
                        </el-row>
                    </el-container>
                </el-main>
            </el-container>
            <el-dialog title="修改排班" :visible.sync="edit_dialogVisible" width="400px">
                <el-form :model="staffSchedule" style="padding-top: 25px">
                    <el-row>
                        <el-form-item label="工作班次:">
                            <el-select v-model="staffSchedule.setId" placeholder="请选择">
                                <el-option v-for="item in timeSetSelectList" :key="item.Id" :label="item.SetName" :value="item.Id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-row>
                    <el-row>
                        <el-form-item label="开始日期:">
                            <el-date-picker v-model="staffSchedule.startTime" align="right" type="date" placeholder="选择日期" :picker-options="pickerOptions2"></el-date-picker>
                        </el-form-item>
                    </el-row>
                    <el-row>
                        <el-form-item label="结束日期:">
                            <el-date-picker v-model="staffSchedule.endTime" align="right" type="date" placeholder="选择日期" :picker-options="pickerOptions2"></el-date-picker>
                        </el-form-item>
                    </el-row>
                    <el-row>
                        <el-form-item label="临时排班:">
                            <el-checkbox v-model="staffSchedule.isTemp"></el-checkbox>
                        </el-form-item>
                    </el-row>
                    <el-row type="flex" justify="end" style="margin-bottom: 15px">
                        <el-button size="small" class="btn-primary" @click="edit_dialogVisible = false">取消</el-button>
                        <el-button size="small" class="btn-primary" @click="editStaffSchedule">提交</el-button>
                    </el-row>
                </el-form>
            </el-dialog>
        </el-container>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [pageLimitMixin],
    name: '',
    components: {
        breadcrumb,
        elTableColumn
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            timeSetSelectList: [],
            edit_dialogVisible: false,
            ids: '',
            entpId: userMsg.EntpId,
            permission: this.$util.getPermission('WorkTimeManage'),
            filterText: '',
            orgList: [],
            treeProps: {
                children: 'Childrens',
                label: 'Name'
            },
            searchData: {
                entpId: userMsg.EntpId,
                setName: '',
                cascadeId: '',
                startTime: '',
                endTime: '',
                page: 1,
                limit: 15,
                dataTime: []
            },
            entpScheduleList: [],
            staffWeekScheduleSearchData: {
                entpId: userMsg.EntpId,
                staffId: '',
                startTime: ''
            },
            staffWeekScheduleList: [],
            staffSchedule: {
                id: '',
                entpId: userMsg.EntpId,
                setId: '',
                startTime: '',
                endTime: '',
                isTemp: false,
                staffIds: ['']
            },
            tableVisible: true,
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            pickerOptions2: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
                shortcuts: [
                    {
                        text: '今天',
                        onClick(picker) {
                            picker.$emit('pick', new Date());
                        }
                    },
                    {
                        text: '昨天',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24);
                            picker.$emit('pick', date);
                        }
                    },
                    {
                        text: '一周前',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', date);
                        }
                    }
                ]
            },
            getIsTempValue(scope) {
                return scope.IsTemp == true ? '临时' : '非临时';
            },
            nowDate: new Date(),
            weekDate: null,
            lastWeek: null,
            nextWeek: new Date(),
            myWorkTimeData: [
                // "data":[
                // {
                //     "DateTime":"2020-04-01",
                //     "TimeSetName":"默认",
                //     "IsTemp":false,
                //     "Times":[
                //         {
                //             "SetId":"1511138a-acf0-4edf-abe0-58dd16637900",
                //             "Sort":7,
                //             "Name":"正常",
                //             "OnDutyHour":9,
                //             "OnDutyMinute":30,
                //             "OffDutyHour":18,
                //             "OffDutyMinute":0,
                //             "OnDutyTime":"09:30",
                //             "OffDutyTime":"18:00"
                //         }
                //     ]
                // },
            ],
            weekday: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
            lastWeekEndData: null,
            lastColor: '',
            tagColor(item) {
                let r = Math.floor(Math.random() * 256);
                let g = Math.floor(Math.random() * 256);
                let b = Math.floor(Math.random() * 256);
                let color = '#' + r.toString(16) + g.toString(16) + b.toString(16);
                if (item.OffDutyTime.search('次日') > -1) {
                    switch (item.part) {
                        case 1:
                            this.lastColor = color;
                            break;
                        case 2:
                            color = this.lastColor;
                            break;
                    }
                }
                return color;
            },
            getTagStyle(item) {
                let style = 'position:relative;left:-10px;text-align:center;';
                let width = item.SpanCount * 60 - item.OnDutyMinute + item.OffDutyMinute;
                let marginLeft = item.OnDutyHour * 60 + item.OnDutyMinute;
                style += 'width:' + width + 'px;margin-left:' + marginLeft + 'px;';
                return style;
            },
            getTagValue(item) {
                let text = item.SpanText;
                let width = item.SpanCount * 60 - item.OnDutyMinute + item.OffDutyMinute;
                let maxLen = width / 10;
                let len = item.SpanText.length;
                if (len >= maxLen) {
                    let sublen = maxLen - len;
                    text = item.SpanText.slice(0, sublen) + '...';
                }
                return text;
            }
        };
    },
    watch: {
        filterText(val) {
            this.$refs.tree.filter(val);
        }
    },
    created() {
        this.GetOrgTreeWithStaff();
        this.getEntpScheduleList();
        this.getTimeSetSelectList();
    },
    mounted() {},
    methods: {
        filterNode(value, data) {
            if (!value) return true;
            return data.Name.indexOf(value) !== -1;
        },
        //获取组织树
        GetOrgTreeWithStaff() {
            this.$util
                .axiosGet({
                    url: '/api/AttendanceSystem/GetOrgTreeWithStaff',
                    data: {
                        entpId: this.entpId
                    }
                })
                .then(res => {
                    if (res.data) {
                        this.orgList = res.data;
                    }
                })
                .catch(err => {});
        },
        //企业班次
        getEntpScheduleList() {
            this.tableVisible = true;
            this.entpScheduleList = [];
            this.$util
                .axiosGet({
                    url: '/api/AttendanceSystem/GetEntpScheduleList',
                    data: this.searchData
                })
                .then(res => {
                    if (res.data) {
                        this.entpScheduleList = res.data;
                    }
                })
                .catch(err => {});
        },
        //获取班次选择列表
        getTimeSetSelectList() {
            this.$util
                .axiosGet({
                    url: '/api/AttendanceSystem/GetTimeSetSelectList',
                    data: {
                        entpId: this.entpId
                    }
                })
                .then(res => {
                    if (res.data) {
                        this.timeSetSelectList = res.data;
                    }
                })
                .catch(err => {});
        },
        //删除员工班次
        delStaffSchedule(scope) {
            if (scope) {
                this.ids = scope.row.StaffId;
            }
            this.$util
                .axiosPost({
                    url: '/api/AttendanceSystem/DelStaffSchedule?ids=' + this.ids
                })
                .then(res => {
                    if (res.errcode == 0) {
                        this.$util.successMsg('删除成功');
                    }
                })
                .catch(err => {});
        },
        onDatePickerChange(value) {
            if (value != null) {
                this.searchData.startTime = value[0];
                this.searchData.endTime = value[1];
            } else {
                this.searchData.startTime = '';
                this.searchData.endTime = '';
            }
        },
        //共三个参数，依次为：传递给 data 属性的数组中该节点所对应的对象、节点对应的 Node、节点组件本身
        handleNodeClick(data, node, VueComponent) {
            this.resetSearchData();
            if (data.Type == 'staff') {
                this.tableVisible = false;
                this.staffWeekScheduleSearchData.staffId = data.Id;
                this.getStaffWeekSchedule(1);
            } else {
                this.tableVisible = true;
                this.searchData.cascadeId = data.CascadeId;
                this.getEntpScheduleList();
            }
        },
        //重置
        resetSearchData() {
            this.searchData = {
                entpId: this.entpId,
                setName: '',
                cascadeId: '',
                startTime: '',
                endTime: '',
                page: 1,
                limit: this.commonPageSize,
                dataTime: []
            };
        },
        //自定义索引
        indexMethod(index) {
            let day = this.weekday[index];
            let date = this.myWorkTimeData[index].DateTime;
            return day + ' ' + date;
        },
        cellMerge({ row, column, rowIndex, columnIndex }) {
            //跳过第一列
            if (columnIndex == 0) {
                return;
            }
            if (columnIndex == 1) {
                return {
                    rowspan: 1,
                    colspan: 24
                };
            }
        },
        //获取本周的第一天日期
        getWeekStartDate() {
            let year = this.nowDate.getFullYear();
            let month = this.nowDate.getMonth() + 1;
            let strDate = this.nowDate.getDate();
            this.today = this.nowDate.getDay();
            let weekStartDate = new Date(year, month, strDate - this.today);
            let sd = weekStartDate.getDate();
            this.weekDate = weekStartDate;
            return this.getFormatDate(year, month, sd);
        },
        //获取上一周
        getLastWeekFormatDate() {
            this.lastWeek = new Date(this.weekDate - 7 * 24 * 3600 * 1000);
            let year = this.lastWeek.getFullYear();
            let month = this.lastWeek.getMonth() + 1;
            let strDate = this.lastWeek.getDate();
            this.weekDate = this.lastWeek;
            return this.getFormatDate(year, month, strDate);
        },
        //获取下一周
        getNextWeekFormatDate() {
            this.nextWeek.setFullYear(this.weekDate.getFullYear());
            this.nextWeek.setMonth(this.weekDate.getMonth());
            this.nextWeek.setDate(this.weekDate.getDate() + 7);
            let year = this.nextWeek.getFullYear();
            let month = this.nextWeek.getMonth() + 1;
            let strDate = this.nextWeek.getDate();
            this.weekDate = this.nextWeek;
            return this.getFormatDate(year, month, strDate);
        },
        //格式化时间格式参数
        getFormatDate(year, month, strDate) {
            let seperator1 = '-';
            if (month < 10) {
                month = '0' + month;
            }
            if (strDate < 10) {
                strDate = '0' + strDate;
            }
            let currentdate = year + seperator1 + month + seperator1 + strDate;
            return currentdate;
        },
        analyzeWorkTimeDate(timesData) {
            let timeData = timesData;
            let spanCount = 0;

            //上班的时长
            if (timeData.OffDutyHour < timeData.OnDutyHour) {
                spanCount = 24 - timeData.OnDutyHour;
            } else if (timeData.OnDutyHour - timeData.OffDutyHour == 0) {
                spanCount = 24;
            } else {
                spanCount = timeData.OffDutyHour - timeData.OnDutyHour;
            }

            // //合并的列数
            timeData.SpanCount = spanCount;

            //展示的文本
            timeData.SpanText = timeData.Name + '(' + timeData.OnDutyTime + '~' + timeData.OffDutyTime + ')';

            return timeData;
        },
        //员工班次
        getStaffWeekScheduleList() {
            this.$util
                .axiosGet({
                    url: '/api/AttendanceSystem/GetStaffWeekScheduleList',
                    data: this.staffWeekScheduleSearchData
                })
                .then(res => {
                    if (res.data) {
                        this.staffWeekScheduleList = res.data;
                    }
                })
                .catch(err => {});
        },
        //员工班次列表
        getStaffWeekSchedule(type) {
            let that = this;
            let today = new Date();
            switch (type) {
                case 1:
                    this.staffWeekScheduleSearchData.startTime = this.getWeekStartDate();
                    break;
                case 2:
                    this.staffWeekScheduleSearchData.startTime = this.getLastWeekFormatDate();
                    break;
                case 3:
                    this.staffWeekScheduleSearchData.startTime = this.getNextWeekFormatDate();
                    break;
            }
            this.getStaffWeekScheduleList();

            this.$util
                .axiosGet({
                    url: '/api/AttendanceSystem/getStaffWeekSchedule',
                    data: this.staffWeekScheduleSearchData
                })
                .then(res => {
                    that.myWorkTimeData = [];
                    if (res.data) {
                        let lastSATday = res.data.shift();
                        let temp = lastSATday.Times.find(item => {
                            return item.OffDutyTime.indexOf('次日') > -1;
                        });

                        that.myWorkTimeData = res.data;
                        if (temp) {
                            that.myWorkTimeData[0].Times.push(temp);
                        }
                        for (let i = 0; i < that.myWorkTimeData.length; i++) {
                            let WorkTimeData = that.myWorkTimeData[i];
                            if (i == 0) {
                                //处理周六的跨日班次
                                let len = WorkTimeData.Times.length;
                                let lastDay = WorkTimeData.Times[len - 1];
                                if (lastDay.Sort == 6) {
                                    lastDay = that.analyzeWorkTimeDate(lastDay);
                                    lastDay.OnDutyHour = 0;
                                }
                            }
                            for (let j = 0; j < WorkTimeData.Times.length; j++) {
                                let element = WorkTimeData.Times[j];
                                element = that.analyzeWorkTimeDate(element);

                                if (element.Sort == i + 1 && element.OffDutyTime.search('次日') > -1) {
                                    //跨日的放到下一行
                                    if (element.OffDutyHour > 0) {
                                        let nextWtd = {
                                            SetId: element.SetId,
                                            Sort: element.Sort + 1,
                                            Name: element.Name,
                                            OnDutyHour: 0,
                                            OnDutyMinute: element.OnDutyMinute,
                                            OffDutyHour: element.OffDutyHour,
                                            OffDutyMinute: element.OffDutyMinute,
                                            OnDutyTime: element.OnDutyTime,
                                            OffDutyTime: element.OffDutyTime,
                                            SpanCount: element.OffDutyHour,
                                            SpanText: element.SpanText,
                                            part: 2
                                        };
                                        element = nextWtd;
                                        that.myWorkTimeData[i + 1].Times.push(nextWtd);
                                    }
                                    let wtd = {
                                        SetId: element.SetId,
                                        Sort: element.Sort,
                                        Name: element.Name,
                                        OnDutyHour: element.OnDutyHour,
                                        OnDutyMinute: element.OnDutyMinute,
                                        OffDutyHour: 24,
                                        OffDutyMinute: element.OffDutyMinute,
                                        OnDutyTime: element.OnDutyTime,
                                        OffDutyTime: element.OffDutyTime,
                                        SpanCount: 24 - element.OnDutyHour,
                                        SpanText: element.SpanText,
                                        part: 1
                                    };
                                    element = wtd;
                                }
                            }
                        }
                    }
                })
                .catch(err => {});
        },
        //显示dialog
        showEditStaffSchedule(scope) {
            if (scope) {
                this.edit_dialogVisible = true;
                this.staffSchedule.id = scope.row.Id;
                let timeSet = this.timeSetSelectList.find(item => {
                    return item.SetName.indexOf(scope.row.SetName) > -1;
                });
                this.staffSchedule.setId = timeSet.Id;
                this.staffSchedule.startTime = scope.row.StartTime;
                this.staffSchedule.endTime = scope.row.EndTime;
                this.staffSchedule.isTemp = scope.row.IsTemp;
                this.staffSchedule.staffIds = [scope.row.StaffId];
            }
        },
        //编辑员工排班
        editStaffSchedule() {
            this.$util
                .axiosPost({
                    url: '/api/AttendanceSystem/EditStaffSchedule',
                    data: this.staffSchedule
                })
                .then(res => {
                    if (res.errcode == 0) {
                        this.$util.successMsg('修改成功');
                    }
                })
                .catch(err => {});
        },
        handleSelectionChange(val) {
            this.ids = '';
            val.forEach(element => {
                this.ids += element.Id + ',';
            });
            this.ids = this.ids.slice(0, this.ids.length - 1);
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getSignRecordsList();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getSignRecordsList();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getEntpScheduleList();
        }
    }
};
</script>
<style lang="less" scoped>
.rowClass {
    width: 100%;
}
</style>
